import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../common/common.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(private commonService: CommonService) { }
  userData = { email: null };
  ngOnInit() {
    this.userData = this.commonService.getUser();
  }

  onLogout() {
    this.commonService.logOut();
  }

  WindowResize(e) {
    setTimeout(() => { window.dispatchEvent(new Event('resize')); }, 260);
    }

    
}
